import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

interface ActionButtonsProps {
  isLoading?: boolean;
  onSave?: () => void;
  onSaveAndClose?: () => void;

  saveLabel?: string;
  saveAndCloseLabel?: string;

  saveColor?: ButtonProps["color"];
  saveAndCloseColor?: ButtonProps["color"];

  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  disabled?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isLoading = false,
  onSave = () => {},
  onSaveAndClose = () => {},

  saveLabel = "ذخیره",
  saveAndCloseLabel = "ذخیره و بستن",

  saveColor = "success",
  saveAndCloseColor = "secondary",

  size = "small",
  variant = "contained",
  disabled = false,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
      <LoadingButton
        loading={isLoading}
        variant={variant}
        color={saveColor}
        size={size}
        onClick={onSave}
        disabled={disabled || isLoading}
      >
        {saveLabel}
      </LoadingButton>
      <LoadingButton
        loading={isLoading}
        variant={variant}
        color={saveAndCloseColor}
        size={size}
        onClick={onSaveAndClose}
        disabled={disabled || isLoading}
      >
        {saveAndCloseLabel}
      </LoadingButton>
    </Box>
  );
};

export default ActionButtons;
